var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSelectedChatGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_26273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0718 1.4917L20.5425 8.96241L17.0447 9.97L13.8265 13.1882L13.1197 17.6304L4.40384 8.91452L8.84604 8.20768L12.0642 4.98953L13.0718 1.4917Z",
    fill: "#98A2B3",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37479 21.1258L7.79149 12.4173L9.62482 14.709L1.37479 21.1258Z",
    fill: "#98A2B3",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_26273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSelectedChatGroup);
export default __webpack_public_path__ + "static/media/pin-selected-chat-group.0231c548797098090a51df8cc0d09ec1.svg";
export { ForwardRef as ReactComponent };